import { createAsyncThunk } from "@reduxjs/toolkit"

import { downloadFileFromResponse, handleApiError } from "../../../Utils/thunkHelpers"
import utils from "../../../Utils/utils"
import * as services from "../services"
import { INVOICES_SLICE_NAME } from "./invoices.constants"

export const getInvoices = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/get_invoices`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInvoices(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const reissueInvoice = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/reissue_invoice`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.reissueInvoice(id)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateInvoice = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/update_invoice`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.updateInvoice(data)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const invoiceGenerating = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/invoice_generating`,
  async (data, { dispatch, rejectWithValue }) => {
    const response = await services.invoiceGenerating(data)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getInvoiceHistory = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/get_invoice_history`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInvoiceHistory(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getInvoicesFilterOptions = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/get_invoices_filter_options`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInvoicesFilterOptions(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getInvoicesStatusOptions = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/get_invoices_status_options`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInvoicesStatusOptions(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// Legacy saga's default (no `message`/`downloadFile`) branch: dispatch success(response.data),
// then follow an external `redirect_url` if present. Neither action configured a static
// `provider.actions.redirect`, so that branch never applied to these two.
export const getInvoicesExportForUser = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/get_invoices_export_for_user`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInvoicesExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    if (response.data?.redirect_url) utils.goLink(response.data.redirect_url)
    return response.data
  }
)

export const getInvoicesExportHistory = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/get_invoices_export_history`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInvoicesExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    if (response.data?.redirect_url) utils.goLink(response.data.redirect_url)
    return response.data
  }
)

// downloadFile: true — legacy saga skipped the success(data) dispatch, triggered the
// browser download, and dispatched success(true) instead (no response body reaches state).
export const getInvoicesExport = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/get_invoices_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInvoicesExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    downloadFileFromResponse(
      response,
      `${params?.file_name || "Report"}${params?.format || ".csv"}`
    )
    return true
  }
)

// downloadFile: true, same shape as getInvoicesExport above.
export const getInvoiceDownload = createAsyncThunk(
  `${INVOICES_SLICE_NAME}/get_invoice_download`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getInvoiceDownload(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    downloadFileFromResponse(
      response,
      `${params?.file_name || "Report"}${params?.format || ".csv"}`
    )
    return true
  }
)
